module.exports = "https://store.zigzag.kr/resources/arm64/20260316-1257-44e674cbc3_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";